import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnChanges } from '@angular/core';
import {
  SecondaryLinksSeoComponent,
  SecondaryNavigationEvent
} from '@com-delta-idp/mnx-sitewide-header-ui';
import {
  AdobeDataLayerService,
  SecondaryNavigationID
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { PushPipe } from '@ngrx/component';
import { SecondaryNavigationLinksFacadeService } from '../../../data-access/facades/secondary-navigation-links/secondary-navigation-links-facade.service';

@Component({
  selector: 'idp-secondary-navigation-links',
  standalone: true,
  imports: [CommonModule, SecondaryLinksSeoComponent, PushPipe],
  templateUrl: './secondary-navigation-links.component.html',
  styleUrls: ['./secondary-navigation-links.component.scss']
})
export class SecondaryNavigationLinksComponent implements OnChanges {
  @Input() navigationId = '';
  @Input() isMobile = false;

  facade = inject(SecondaryNavigationLinksFacadeService);
  adobeAnalytics = inject(AdobeDataLayerService);

  ngOnChanges(): void {
    this.facade.init(this.navigationId);
  }

  emitAdobeAnalytics(e: SecondaryNavigationEvent): void {
    this.adobeAnalytics.appNavLinksAnalytics(
      e.id as SecondaryNavigationID,
      e.brandLabel,
      e.url
    );
  }
}
